import React from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Info } from 'lucide-react';

interface FingerprintConsentCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

export const FingerprintConsentCheckbox: React.FC<FingerprintConsentCheckboxProps> = ({
  checked,
  onCheckedChange,
  disabled = false,
  className = ""
}) => {
  return (
    <div className={`space-y-3 ${className}`}>
      {/* Checkbox principal */}
      <div className="flex items-start space-x-3">
        <Checkbox
          id="fingerprint-consent"
          checked={checked}
          onCheckedChange={onCheckedChange}
          disabled={disabled}
          className="mt-1"
        />
        <div className="flex-1">
          <label 
            htmlFor="fingerprint-consent" 
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
          >
            J'accepte la collecte anonyme de mon empreinte device (optionnel)
          </label>
          <p className="text-xs text-gray-600 mt-1">
            Aide à détecter les soumissions multiples frauduleuses
          </p>
        </div>
      </div>

      {/* Informations détaillées */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
        <div className="flex items-start space-x-2">
          <Info className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="text-xs text-blue-800 space-y-1">
            <p className="font-medium">Qu'est-ce que l'empreinte device ?</p>
            <ul className="list-disc list-inside space-y-0.5 ml-2">
              <li>Informations techniques anonymes (résolution écran, navigateur, etc.)</li>
              <li>Aucune donnée personnelle collectée</li>
              <li>Utilisé uniquement pour détecter les fraudes</li>
              <li>Supprimé automatiquement après 90 jours</li>
            </ul>
            <p className="font-medium mt-2">Vos droits RGPD :</p>
            <ul className="list-disc list-inside space-y-0.5 ml-2">
              <li>Consentement libre et révocable à tout moment</li>
              <li>Droit d'opposition et de suppression</li>
              <li>Traitement basé sur l'intérêt légitime (Art. 6.1.f)</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Statut du consentement */}
      {checked && (
        <div className="text-xs text-green-700 bg-green-50 border border-green-200 rounded px-2 py-1">
          ✅ Consentement accordé - Empreinte device sera collectée de manière anonyme
        </div>
      )}
    </div>
  );
};